import { Box, Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import { useCallback, useEffect, useState } from 'react'
import { normalizeString } from '../../../utils/normalizeString'

export function FiltroLayout({ setLayouts, layouts }) {
  const [inputValue, setInputValue] = useState({
    nota: '',
    vendedor: '',
  })

  function handleInputValue(e) {
    setInputValue({
      ...inputValue,
      [e.target.name]: String(e.target.value),
    })
  }

  const handleFilterLayouts = useCallback(() => {
    if (!inputValue.nota && !inputValue.vendedor) {
      setLayouts(layouts)
      return
    }
    const { nota, vendedor } = inputValue

    const searchedValueVendedor = normalizeString(vendedor).trim()

    let initialData = layouts

    if (nota) {
      initialData = initialData.filter((item) =>
        item.numero_innovation.includes(nota.trim())
      )
    }

    if (vendedor) {
      initialData = initialData.filter((item) =>
        normalizeString(item.nome_vendedor).includes(searchedValueVendedor)
      )
    }

    if (vendedor && nota) {
      initialData = initialData.filter(
        (item) =>
          normalizeString(item.nome_vendedor).includes(searchedValueVendedor) &&
          item.numero_innovation.includes(nota.trim())
      )
    }

    setLayouts(initialData)
  }, [inputValue, layouts, setLayouts])

  useEffect(() => {
    handleFilterLayouts()
  }, [inputValue])

  return (
    <Box mt="4" display="flex" alignItems="center" gap="2">
      <InputGroup>
        <InputLeftAddon children="Nota" />
        <Input
          type="number"
          name="nota"
          value={inputValue.nota}
          onChange={handleInputValue}
          placeholder="Digite o número innovation"
        />
      </InputGroup>
      <InputGroup>
        <InputLeftAddon children="Vendedor" />
        <Input
          type="text"
          name="vendedor"
          value={inputValue.vendedor}
          onChange={handleInputValue}
          placeholder="Digite o nome do vendedor"
        />
      </InputGroup>
    </Box>
  )
}
